import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { useIntl } from '../intl/useIntl';
import { usePersonalProfile } from '../entities/usePersonalProfile';
import { useInstrumentListWithDetails } from '../treasury/useInstrumentListWithDetails';

/** @category Contracts */
export function useContractForRender(contract, profileId) {
  const tokenizedApi = useTokenizedApi();
  const intl = useIntl();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const contractId = contract?.draft?.id || contract?.contractAddress;
  const contractInstruments = useQuery({
    ...tokenizedApi.contracts.contractInstrumentsQuery({
      profileId,
      contractId,
    }),
    // Since instruments contain editable data (drafts), we want to
    // reload every time the hook’s component mounts
    refetchOnMount: 'always',
  })?.data?.instruments;

  const requestedOtherInstruments = [
    ...(tokenizedApi.contracts.instrumentsNeededForContractPreparation(
      contract,
      contractInstruments,
    ) || []),
  ];
  const otherInstruments = useInstrumentListWithDetails(
    requestedOtherInstruments,
    profileId,
  );
  const otherInstrumentsById = new Map(
    otherInstruments.map((instrument, index) => [
      requestedOtherInstruments[index],
      instrument,
    ]),
  );

  return tokenizedApi.contracts.prepareContractForRender({
    contract,
    contractInstruments,
    intl,
    otherInstrumentsById,
  });
}
